(function ($) {
    $(function () {

        if ($('.template__login').length === 0) {
            return;
        }


        $(document).on("submit", ".js-login-form", function (e) {
            e.preventDefault();

            var theForm = $(this);
            var data = grabFormAsObject(theForm);

            if (typeof data.remember === "undefined") {
                data.remember = false;
            }


            if (validateJsFormRequire(theForm, true)) {
                $('.js-login').removeClass('button--disabled')
                return false;
            }


            apiGetCall("user/login", data, (error, result) => {


                if (result.error) {
                    if (result.error == "Nem megfelelő belépési adatok") {
                        theForm.show();
                        if (error) {
                            $('.js-wrong-login-datas').removeClass('d-none');
                        }
                        return false;
                    } else {
                        $('.js-error-login').text(result.error).removeClass('d-none');
                        window.scrollTo(0, 0);
                        setTimeout(function () {
                            $('.js-error-login').addClass('d-none');
                        }, 3200);
                    }
                }

                $('.js-login').removeClass('button--disabled')

                let expires = 1;

                if (result.token) {
                    Cookies.set("token", result.token, { expires });
                    window.location.href = localize.siteurl;
                }
            });
            return false;
        });


        $('.js-login-facebook').on('click', function (e) {
            e.preventDefault();

            FB.login(function (fbresponse) {
                if (fbresponse.authResponse) {
                    FB.api('/me', { locale: 'en_US', fields: 'id' },
                        function (response) {

                            fbdata = {
                                'fbid': response.id,
                                'accessToken': fbresponse.authResponse.accessToken,
                                'lang': $.langCookie
                            };

                            facebookLogin(fbdata);

                        });

                } else {
                    $('.js-error-login').text(localize.translations.loginToFB).removeClass('d-none')
                    window.scrollTo(0, 0);
                    setTimeout(function () {
                        $('.js-error-login').addClass('d-none');
                    }, 3200);
                }
            }, { scope: 'email' });

        });
    });
})(jQuery);